import { useMemo } from 'react'

import { useGetContactOnMount } from '@user/store/contacts'
import { initialValues, type IUpdateContactFormModel } from '../typings'

export function useData(props: { contactId?: number }) {
  const { contactId } = props

  const { contact, status } = useGetContactOnMount(contactId)

  const hydratedInitialValues = useMemo<IUpdateContactFormModel>(() => {
    if (contact) {
      return {
        ...initialValues,
        altPhoneExt: contact.altPhoneExt,
        altPhoneNumber: contact.altPhoneNumber,
        city: contact.city,
        company: contact.company,
        contactMethod: contact.contactMethod ?? '',
        contactTime: contact.contactTime ? contact.contactTime.split(',') : [],
        firstName: contact.firstName,
        id: contact.id,
        lastName: contact.lastName,
        phoneExt: contact.phoneExt,
        phoneNumber: contact.phoneNumber,
        postalCode: contact.postalCode,
        state: contact.stateAbbreviation,
        address1: contact.street1,
        address2: contact.street2,
        timeZone: contact.timeZone ?? 'Eastern Standard Time',
        emailAddresses: contact.emailAddresses,
      }
    } else {
      return initialValues
    }
  }, [contact])

  return {
    status,
    contact,
    initialValues: hydratedInitialValues,
  }
}
